<!--新闻详情-->
<template>
    <div class="NewsView">
        <app-breadcrumb />
        <div class="page-container account">
            <div class="filter">
                <div>
                    <h1 style="text-align: center">{{ viewObj.title }}</h1>
                    <p style="text-align: center; margin-bottom: 10px">
                        <span style="color: blue; font-size: 16px">{{ $t('busi.message.issuetime') }}</span>: <span>{{
              viewObj.createTime }}</span>&nbsp;&nbsp;
                        <span style="color: blue; font-size: 16px">{{ $t('Common.creator') }}</span>: <span> {{ viewObj.creatorCode
              }}</span>&nbsp;&nbsp;
                        <span style="color: blue; font-size: 16px">{{ $t('bdBonus.origin') }}</span>: <span> {{ viewObj.fromCompany
              }}</span>&nbsp;&nbsp;
                    </p>
                    <p style="padding: 10px" v-html="viewObj.content" />
                </div>
            </div>
        </div>
        <el-button style="text-align: right" type="primary" @click="viewDialong">{{ $t('operation.button.return') }}</el-button>
    </div>
</template>
<script>
import { icAnnouncesView } from '@/api/ic/IcAnnounce'
export default {
    name: 'NewsView',
    data() {
        return {
            viewObj: {},
            announceId: this.$route.params.id,
        }
    },
    created() {
        if (this.announceId) {
            icAnnouncesView({ 'id': this.announceId }).then(res => {
                this.viewObj = res.data
            }).catch(() => {
                this.$router.go(-1)
            })
        } else {
            this.$router.go(-1)
        }
    },
    methods: {
        viewDialong() {
            this.$router.replace({name: 'News'})
        }
    }
}
</script>
<style scoped>

</style>
